// A single flower: a thin stem, a ring of five petal blobs and a bright centre.
// The petal colour comes from the variant. Ported 1:1 from age-of-mcp's classic
// flower.ts, restoring its petal-ring loop and per-variant palette.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const TAU = Math.PI * 2;
// Petal colours — one per variant, picked deterministically per tile.
const PETALS = ["#f06e7e", "#f4d35e", "#dcbcff", "#8ad8ff", "#ffb454"];

function partsFor(variant: number): Part[] {
  const petal = PETALS[variant % PETALS.length]!;
  const parts: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.004, 0.006, 0.07, 4),
      color: "#2f6a28", position: [0, 0.035, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.013, 0),
      color: "#fff1c2", position: [0, 0.075, 0] },
  ];
  for (let i = 0; i < 5; i++) {
    const a = (i / 5) * TAU;
    parts.push({
      geometry: new THREE.IcosahedronGeometry(0.014, 0),
      color: petal,
      position: [Math.cos(a) * 0.022, 0.075, Math.sin(a) * 0.022],
    });
  }
  return parts;
}

export const flower = defineModel({
  id: "flower",
  batchId: "standard",
  name: "Flower",
  tags: ["scenery","flower","low-poly","age-of-mcp","classic"],
  summary: "Low-poly flower.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => partsFor(0) },
    { id: "variant-1", label: "Variant 2", parts: () => partsFor(1) },
    { id: "variant-2", label: "Variant 3", parts: () => partsFor(2) },
    { id: "variant-3", label: "Variant 4", parts: () => partsFor(3) },
    { id: "variant-4", label: "Variant 5", parts: () => partsFor(4) },
  ],
  animations: [],
});
